export interface CronScheduleOption {
  label: string;
  value: string;
  description: string;
}

export const CRON_SCHEDULE_OPTIONS: CronScheduleOption[] = [
  // Common schedules
  { label: 'Manual only (no schedule)', value: '', description: 'Run only when manually triggered' },
  { label: 'Every minute', value: '* * * * *', description: 'Run every minute' },
  { label: 'Every hour', value: '0 * * * *', description: 'Run at the start of every hour' },
  { label: 'Daily at midnight', value: '0 0 * * *', description: 'Run once per day at 12:00 AM' },
  { label: 'Daily at 9 AM', value: '0 9 * * *', description: 'Run once per day at 9:00 AM' },
  { label: 'Daily at 6 PM', value: '0 18 * * *', description: 'Run once per day at 6:00 PM' },

  // Weekly schedules
  { label: 'Weekly on Monday at 9 AM', value: '0 9 * * 1', description: 'Run every Monday at 9:00 AM' },
  { label: 'Weekly on Sunday at midnight', value: '0 0 * * 0', description: 'Run every Sunday at 12:00 AM' },
  { label: 'Weekdays at 9 AM', value: '0 9 * * 1-5', description: 'Run Monday through Friday at 9:00 AM' },
  { label: 'Weekends at 10 AM', value: '0 10 * * 0,6', description: 'Run Saturday and Sunday at 10:00 AM' },

  // Monthly schedules
  { label: 'Monthly on 1st at 9 AM', value: '0 9 1 * *', description: 'Run on the 1st of every month at 9:00 AM' },
  { label: 'Monthly on 15th at 2 PM', value: '0 14 15 * *', description: 'Run on the 15th of every month at 2:00 PM' },

  // Custom intervals
  { label: 'Every 15 minutes', value: '*/15 * * * *', description: 'Run every 15 minutes' },
  { label: 'Every 30 minutes', value: '*/30 * * * *', description: 'Run every 30 minutes' },
  { label: 'Every 2 hours', value: '0 */2 * * *', description: 'Run every 2 hours' },
  { label: 'Every 6 hours', value: '0 */6 * * *', description: 'Run every 6 hours' },
  { label: 'Twice daily (9 AM & 5 PM)', value: '0 9,17 * * *', description: 'Run at 9:00 AM and 5:00 PM daily' },
  { label: 'Custom...', value: 'custom', description: 'Enter a custom cron expression' }
];

